import { createAction } from '@ngrx/store';

export const enum GetRetentionSummaryTypes {
  GET = '[Retention] Get retention summary',
}

export const getRetentionSummaryAction = createAction(
  GetRetentionSummaryTypes.GET
);
